<template>
  <div class="new-trade-card" v-if="trade && stock">
    <span class="card--tag" style="background: #ff895a; color: white"
      >Trade (Order)</span
    >
    <!-- <div class="portfolio-trade-topbar">
      <p class="open-text" v-if="trade.tradeStatus === 'partiallyClosed'">
        Partially Closed
      </p>
      <p class="open-text" v-else-if="trade.tradeStatus === 'close'">Closed</p>
      <p class="open-text" v-else>{{ trade.tradeStatus }}</p>
      <div class="endDv">
        <IconComponent
          path=""
          className="portfolioTradeiconDv"
          icon="second-leaderboard-icon.svg"
        />
      </div>
    </div> -->
    <div class="new-trade-card-head">
      <StockImageTag
        v-if="!tradeChanging"
        :stockId="trade.stockId"
        :symbol="trade.symbol"
        :market="trade.stockType ? trade.stockType : extractedStockId"
        :disableRouting="false"
        style="margin-top: -6px"
      />
      <div class="txtDv">
        <h6>{{ trade.symbol ?? "-" }}</h6>
        <div class="secondDv">
          <p class="symbolTitle">
            {{ stockName ?? trade.name ?? "-" }}
          </p>
        </div>
      </div>
      <div class="profitDv">
        <p
          v-html="
            $filters.systemNumberConvention(stock.price, true, false, 110)
          "
        ></p>
        <h6
          v-if="stock && stock.changesPercentage"
          :class="{ downward: stock.changesPercentage < 0 }"
        >
          <IconComponent class="priceIcon" icon="stock-pricing-up-icon.svg" />
          {{
            $filters.systemNumberConvention(
              stock.changesPercentage,
              false,
              false
            )
          }}%
        </h6>
      </div>
    </div>
    <div class="new-trade-card-middle">
      <div class="position-container">
        <h5>Order:</h5>
        <p
          v-if="trade.side === 'sell'"
          style="color: #ff3b3b; background: rgba(255, 59, 59, 0.1)"
        >
          {{ trade.side }}
        </p>
        <p v-else>{{ trade.side }}</p>
      </div>
      <div class="type-container">
        <h5>Type:</h5>
        <p>DayTrade</p>
      </div>
    </div>
    <div class="new-trade-card-body">
      <div class="col">
        <h5>Shares</h5>
        <h6
          v-html="
            $filters.systemNumberConvention(tradeQuantity, false, false, 100)
          "
        ></h6>
      </div>
      <div class="col">
        <h5>P/Price</h5>
        <h6
        v-if="trade.limit_price"
          v-html="
            $filters.systemNumberConvention(trade.limit_price, true, false, 100)
          "
        ></h6>
        <h6 v-else
          v-html="
            $filters.systemNumberConvention(trade.entry_price ? trade.entry_price : trade.buyPrice, true, false, 100)
          "
        ></h6>
      </div>
      <div class="col">
        <h5>Total</h5>
        <h6
           v-if="trade.limit_price"
          v-html="
            $filters.systemNumberConvention(trade.limit_price * tradeQuantity, true, false, 100)
          "
        ></h6>
        <h6
        v-else
          v-html="
            $filters.systemNumberConvention((trade.entry_price ? trade.entry_price : trade.buyPrice) * tradeQuantity, true, false, 100)
          "
        ></h6>
      </div>
      <div class="col">
        <h5>Gain</h5>
        <!-- :class="{ negative: overallGainPercent < 0 }" -->

        <h6
            class="gainGreen"
            :class="{ negative: overallGainPercent < 0 }"
            >  <IconComponent class="priceIcon" icon="stock-pricing-up-icon.svg" />
            {{ $filters.systemNumberConvention(
                overallGainPercent,
                false,
                true,
                100
                )}}%</h6>
      </div>
      <!-- <div class="col">
        <h5>Gain</h5>
        <span
          v-if="!buyTradeOrNot && !sellTradeOrNot"
          class="gainGreen"
          :class="{ negative: trade.gainPercent < 0 }"
          style="display: flex; align-items: center"
        >
        <template v-if="trade.gainPercent">
            <template v-if="trade.gainPercent < 0">
              -
              <h6
                class="gainGreen"
                v-html="
                  $filters.systemNumberConvention(
                    trade.gainPercent,
                    false,
                    true,
                    100
                  )
                "
                :class="{ negative: trade.gainPercent < 0 }"
              ></h6>
            </template>
            <template v-if="trade.gainPercent == 0">
              <h6 class="gainGreen">0</h6>
            </template>
            <template v-if="trade.gainPercent > 0">
              <h6
                class="gainGreen"
                v-html="
                  $filters.systemNumberConvention(
                    trade.gainPercent,
                    false,
                    true,
                    100
                  )
                "
                :class="{ negative: trade.gainPercent < 0 }"
              ></h6>
            </template>
            %
        </template> 
        <template v-else>
            0%
        </template>
        </span>
        <span
          v-if="buyTradeOrNot && !sellTradeOrNot"
          class="gainGreen"
          :class="{ negative: overallGainPercent < 0 }"
          style="display: flex; align-items: center"
        >
        <template v-if="overallGainPercent">
            <template v-if="overallGainPercent < 0">
              -
              <h6
                class="gainGreen"
                v-html="
                  $filters.systemNumberConvention(
                    overallGainPercent,
                    false,
                    true,
                    100
                  )
                "
                :class="{ negative: overallGainPercent < 0 }"
              ></h6>
            </template>
            <template v-if="overallGainPercent == 0">
              <h6 class="gainGreen">0</h6>
            </template>
            <template v-if="overallGainPercent > 0">
              <h6
                class="gainGreen"
                v-html="
                  $filters.systemNumberConvention(
                    overallGainPercent,
                    false,
                    true,
                    100
                  )
                "
                :class="{ negative: overallGainPercent < 0 }"
              ></h6>
            </template>
            %
        </template>
        <template v-else>
            0%
        </template>
        </span>
        <span
          v-if="sellTradeOrNot && !buyTradeOrNot"
          class="gainGreen"
          :class="{ negative: overallGainPercent < 0 }"
          style="display: flex; align-items: center"
        >
        <template v-if="overallGainPercent">
            <template v-if="overallGainPercent < 0">
              -
              <h6
              class="gainGreen"
              v-html="
                $filters.systemNumberConvention(
                  overallGainPercent,
                  false,
                  true,
                  100
                )
              "
              :class="{ negative: overallGainPercent < 0 }"
            ></h6>
          </template>
          <template v-if="overallGainPercent == 0">
            <h6 class="gainGreen">0</h6>
          </template>
          <template v-if="overallGainPercent > 0">
            <h6
              class="gainGreen"
              v-html="
                $filters.systemNumberConvention(
                  overallGainPercent,
                  false,
                  true,
                  100
                )
              "
              :class="{ negative: overallGainPercent < 0 }"
            ></h6>
          </template>
          %
        </template>
        <template v-else>
            0%
        </template>
        </span>
      </div> -->
    </div>
    <div class="new-trade-card-footer">
      <div class="user-container" >
        <ProfileAvatarComponent
          v-if="postUser"
          :key="postUser.profilePicture"
          :profileImage="postUser.profilePicture"
          :border="true"
          :badges="false"
          class="small"
        />
        <ProfileAvatarComponent
          v-else
          :key="images.profilePicture"
          :profileImage="images.profilePicture"
          :border="true"
          :badges="false"
          class="small"
        />
        <p>{{ postUser ? postUser.fullName : user.fullName }}</p>
      </div>
      <div class="order-container">
            <IconComponent icon="icon-trade-orders.svg" />
            <p>{{ formattedOrderDate }}</p>
        </div>
      <!-- <el-popover
        popper-style="border-radius: 10px;"
        placement="bottom"
        trigger="hover"
        :width="360"
      >
        <template #reference>
          <div class="order-container">
            <IconComponent icon="icon-trade-orders.svg" />
            <p>{{ trade.totalOrders }} Orders</p>
          </div>
        </template>
        <div class="HoverTradeCardDv">
          <div class="HeadingDv">
            <h2>Orders</h2>
          </div>
          <template v-for="(ordersGroup, date) in groupedOrders" :key="date">
            <div class="StockDv">
              <div class="firstDv">
                <StockImageTag
                  :stockId="trade.stockId"
                  :symbol="trade.symbol"
                  :market="trade.stockType"
                  :disableRouting="true"
                />
                <div class="TextDv">
                  <h2>{{ trade.symbol ?? "-" }}</h2>
                  <p>{{ trade.companyName ?? "-" }}</p>
                </div>
              </div>
              <div class="endDv">
                <p>{{ date }}</p>
              </div>
            </div>
            <template v-for="order in ordersGroup" :key="order.orderDate">
              <div class="tradeInnerCardDv">
                <div class="firstDv">
                  <h2>Order</h2>
                  <p v-if="order.type === 'sell'" style="color: #ff3b3b">
                    {{ order.type }}
                  </p>
                  <p v-else>{{ order.type }}</p>
                </div>
                <div class="secondDv">
                  <h2>Share</h2>
                  <p
                    v-html="
                      $filters.systemNumberConvention(
                        order.shares,
                        false,
                        false,
                        100
                      )
                    "
                  ></p>
                </div>
                <div class="thirdDv">
                  <h2>Price</h2>
                  <p
                    v-html="
                      $filters.systemNumberConvention(
                        order.price,
                        true,
                        false,
                        100
                      )
                    "
                  ></p>
                </div>
                <div class="fourthDv">
                  <h2>Total</h2>
                  <p
                    v-html="
                      $filters.systemNumberConvention(
                        order.totalPrice,
                        true,
                        false,
                        100
                      )
                    "
                  ></p>
                </div>
              </div>
            </template>
          </template>
        </div>
      </el-popover> -->
    </div>
  </div>
</template>

<script lang="ts">
import IconComponent from "@/components/IconComponent.vue";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { useStockSocket } from "@/composables/stock_socket.composable";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  watch,
} from "vue";
import moment from 'moment';

export default defineComponent({
  components: {
    IconComponent,
    ProfileAvatarComponent,
  },
  props: {
    trade: Object,
    postUser: Object,
    stockName: String,
  },
  setup(props) {
    const tradeChanging = ref(false);
    const buyTradeOrNot = ref(false);
    const sellTradeOrNot = ref(false);
    const overallGainPrice = ref();
    const overallGainPercent = ref();

    const { addStockId, checkStockExistence } = useStockSocket();

    const initialObject = () => {
      let obj = {
        _id: props.trade?.stockId,
        type: props.trade?.stockType,
        symbol: props.trade?.symbol,
        stockId: props.trade?.stockId,
      };
      if (!checkStockExistence(props.trade?.stockId)) {
        addStockId({ showTrendChart: true, stockId: props.trade?.stockId });
      }
      return obj;
    };

    const { stockData: stock, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );

    const calculateGains = () => {
        let price
        if(props.trade && props.trade.limit_price){
            price = props.trade.limit_price
        } else {
            price = props.trade.entry_price ? props.trade.entry_price : props.trade.buyPrice;
        }
        if(props.trade){
            return overallGainPercent.value = ((stock.value?.price - price) / price) * 100;
        }
    //   if (props.trade!.orders && props.trade!.orders.length) {
    //     buyTradeOrNot.value = props.trade!.orders.every(
    //       (order) => order.type === "buy"
    //     );
    //     sellTradeOrNot.value = props.trade!.orders.every(
    //       (order) => order.type === "sell"
    //     );

    //     if (buyTradeOrNot.value || sellTradeOrNot.value) {
    //       overallGainPrice.value = props.trade!.orders.reduce(
    //         (totalGain, order) => {
    //           const gain = (stock.value!.price! - order.price) * order.shares;
    //           return totalGain + gain;
    //         },
    //         0
    //       );
    //       const totalPurchasePrice = props.trade!.orders.reduce(
    //         (total, order) => {
    //           return total + order.price * order.shares;
    //         },
    //         0
    //       );
    //       overallGainPercent.value =
    //         (overallGainPrice.value / totalPurchasePrice) * 100;
    //     }
    //   }
    };

    // Single watch for props.trade
    watch(
      () => props.trade,
      async (newStockData) => {
        updateStockInfoObject(initialObject());
        await nextTick();
        calculateGains();
      },
      { deep: true }
    );

    // Single watch for stock changes
    watch(
      () => stock.value,
      (newStockData) => {
        if (newStockData && newStockData.price) {
          calculateGains();
        }
      },
      { deep: true, immediate: true }
    );

    // Single watch for orders changes
    watch(() => props.trade!.orders, () => {
      calculateGains();
    });

    const images = ref<any>({
      profilePicture: "",
      coverPhoto: "",
    });

    const user = ref<any>();

    const groupedOrders = computed(() => {
      const grouped: Record<string, any[]> = {};
      if (props.trade!.orders) {
        props.trade!.orders.forEach((order: any) => {
          const orderDate = order.orderDate;
          if (!grouped[orderDate]) {
            grouped[orderDate] = [];
          }
          grouped[orderDate].push(order);
        });
      }
      const sortedGroupedOrders: Record<string, any[]> = {};
      Object.keys(grouped)
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
        .forEach((key) => {
          sortedGroupedOrders[key] = grouped[key];
        });

      return sortedGroupedOrders;
    });

    const formattedOrderDate = computed(() => {
      if (props.trade?.created_at) {
        return moment(props.trade.created_at).format('MM/DD/YYYY');
      }
      return props.trade?.orderDate || '';
    });

    const tradeQuantity = computed(() => {
      return props.trade?.Qty || props.trade?.quantity || 0;
    });

    const extractedStockId = computed(() => {
      if (props.trade?.stockId) {
        const parts = props.trade.stockId.split('_');
        return  props.trade.stockType ? props.trade.stockType :  parts[1].toLowerCase();
      }
      return '';
    });

    onMounted(() => {
      updateStockInfoObject(initialObject());
      user.value = storageService.getUser();
      images.value.profilePicture = utilService.getUserProfilePicture(
        user.value._id!,
        user.value.profilePicture!,
        "male",
        false,
        false
      );
      images.value.coverPhoto = utilService.getUserProfilePicture(
        user.value._id!,
        user.value.coverPhoto!,
        "male",
        true,
        false
      );
      calculateGains();
    });

    return {
      images,
      user,
      buyTradeOrNot,
      overallGainPercent,
      stock,
      groupedOrders,
      sellTradeOrNot,
      tradeChanging,
      formattedOrderDate,
      tradeQuantity,
      extractedStockId,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "./portfoliotradecard";
.ordersTooltip {
  border-radius: 10px !important;
}
</style>
